<template>
    <div class="animated fadeIn operatorsAnalysis">

        <filters :scope="filtersScope">
        </filters>

        <OperatorsTab></OperatorsTab>

        <div class="filters__atalytics">
            <div class="filters__atalytics--title card-header">
                <i aria-hidden="true" class="fa fa-filter"></i>
                Фильтры по анализу
            </div>
            <div class="filters__atalytics--content">
                <div class="content__percent">
                    <label class="percent-label" for="percent">
                        <input type="number" id="percent" v-model="percent" @change="getPercent">
                        Значение: < {{percent}}%</label>
                </div>
            </div>
        </div>

        <div class="container__table excel" style="overflow:hidden; width:100%">
            <div id="swipe" v-hammer:pan="onSwipe" style="display:flex;flex-wrap: nowrap; width: 100%;" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}">
                <StatisticTable :footColumns="firstFootColumns"
                                :headColumns="headColumns"
                                :rows="rows_first"
                                title="Первый период"
                                class="first-period"
                                @isPopup="isPopup"
                >
                </StatisticTable>
                <StatisticTable :footColumns="secondFootColumns"
                                :headColumns="headColumns"
                                :rows="rows_second"
                                title="Второй период"
                                @isPopup="isPopup"
                >
                </StatisticTable>
                <StatisticTable
                        :footColumns="differenceFootColumns"
                        :headColumns="headColumnsDifference"
                        :rows="rows_difference"
                        title="Разница"
                        class="table_difference"
                >
                </StatisticTable>
                <StatisticTable
                        :footColumns="lastFootColumns"
                        :headColumns="headColumnsLst"
                        :rows="rows_last"
                        title="Последняя неделя"
                        @isPopup="isPopup"
                >
                </StatisticTable>
            </div>
        </div>

    </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'
  import OperatorsTab from './OperatorsTab'
  import StatisticTable from '../../../components/StatisticTable'
  import API from '../../../api/API'
  import {map} from 'lodash'
  import Helper from '../../../api/Helper'
  import Storage from '../../../api/Storage'

  export default {
    components: {
      Filters,
      StatisticTable,
      OperatorsTab
    },
    data () {
      return {
        x: 0,
        filtersScope: {
          dateFilter: true,
          dateFilterSecond: true,
          offerFilter: true,
          byWmFilter: true
        },
        headColumns: [
          {label: this.$root.$t('statistic.operator'), field: 'operator'},
          {label: this.$root.$t('statistic.accepted'), field: 'accepted'},
          {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback'},
          {label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
          {label: this.$root.$t('statistic.revenue_lead'), field: 'revenue_lead'},
          {label: this.$root.$t('statistic.deviation_mean'), field: 'deviation_mean'}
        ],
        rows_first: [],
        firstFootColumns: {},
        rows_second: [],
        secondFootColumns: {},
        rows_difference: [],
        headColumnsDifference: [
          {label: this.$root.$t('statistic.revenue_lead'), field: 'revenue_lead'},
          {label: this.$root.$t('statistic.paid'), field: 'paid'}
        ],
        differenceFootColumns: {},
        headColumnsLst: [
          {label: this.$root.$t('statistic.operator'), field: 'operator'},
          {label: this.$root.$t('statistic.processed_leads'), field: 'processed'}
        ],
        rows_last: [],
        lastFootColumns: {},
        percent: 0,
        operators: []
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      isPopup (cell) {
        let el = document.createElement('textarea')
        el.value = cell.value.trim()
        el.setAttribute('readonly', '')
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        alert('Скопирован оператор ' + el.value)
      },
      onSwipe (e) {
        const offset = document.getElementById('swipe').offsetWidth
        const scroll = document.getElementById('swipe').scrollWidth
        const width = scroll - offset
        if (width > 0) {
          if (e.deltaX >= 0) {
            this.x += e.distance / 10
          } else {
            this.x -= e.distance / 10
          }
          if (this.x > 0) {
            this.x = 0
          }
          if (Math.abs(this.x) > width) {
            this.x = -width
          }
        }
      },
      getPercent () {
        this.rows_first.forEach(item => {
          if (parseFloat(this.percent) > parseFloat(item.paidPercents.value.replace(',', '.'))) {
            item.operator.percentBg = true
          } else {
            item.operator.percentBg = false
          }
        })
        this.rows_second.forEach(item => {
          if (item.paidPercents.value && (parseFloat(this.percent) > parseFloat(item.paidPercents.value.replace(',', '.')))) {
            item.operator.percentBg = true
          } else {
            item.operator.percentBg = false
          }
        })
      },
      sortRows (firstArr, secondArr, lastArr) {
        let firstPeriod = []
        let secondPeriod = []
        let lastPeriod = []
        let existsValues = []
        let existsValuesSecond = []
        firstArr.sort(function (a, b) {
          if (parseInt(a.approved) > parseInt(b.approved)) {
            return -1
          } else {
            return 1
          }
        })

        firstPeriod = firstArr
        for (let iFirst in firstArr) {
          let toPush = []
          let arrValue = firstArr[iFirst]
          existsValues.push(firstArr[iFirst].operator_id)
          for (let iSecond in secondArr) {
            if (!secondArr.hasOwnProperty(iSecond)) {
              continue
            }
            let value = secondArr[iSecond]
            if (value['operator_id'] === arrValue['operator_id']) {
              toPush = value
              break
            }
          }
          secondPeriod.push(toPush)
        }
        for (let val in secondArr) {
          if (!firstArr.hasOwnProperty(val)) {
            continue
          }
          if (secondArr[val].total_percent) {
            let unsortValue = secondArr[val]
            if (existsValues.indexOf(unsortValue['operator_id']) === -1) {
              firstPeriod.push({})
              secondPeriod.push(unsortValue)
            }
          }
        }
        let secondPeriod2 = []
        for (let val in secondPeriod) {
          let arrValue = secondPeriod[val]
          existsValuesSecond.push(arrValue['operator_id'])
          let toPush = []
          for (let unsortVal in lastArr) {
            if (!lastArr.hasOwnProperty(unsortVal)) {
              continue
            }
            if (lastArr[unsortVal].total_percent) {
              let unsortValue = lastArr[unsortVal]
              if (unsortValue['operator_id'] === arrValue['operator_id']) {
                if (unsortValue.total_percent) {
                  toPush = unsortValue
                  break
                }
              }
            }
          }
          secondPeriod2.push(secondPeriod[val])
          lastPeriod.push(toPush)
        }
        for (let val in lastArr) {
          if (!secondPeriod2.hasOwnProperty(val)) {
            continue
          }
          if (lastArr[val].total_percent) {
            let lastValue = lastArr[val]
            if (existsValuesSecond.indexOf(lastValue['operator_id']) === -1) {
              secondPeriod2.push({})
              lastPeriod.push(lastValue)
            }
          }
        }

        return [firstPeriod, secondPeriod, lastPeriod]
      },
      async calculateRows () {
        this.rows_first = []
        this.rows_second = []
        this.rows_difference = []
        this.rows_last = []
        let firstPeriod = []
        let secondPeriod = []
        let lastPeriod = []
        this.operators = []
        await API.getOperators(Helper.getCountryList()).then(operators => {
          this.operators = operators.body
        })
        await API.getOperatorsAnalysis().then(response => {
          [firstPeriod, secondPeriod, lastPeriod] = this.sortRows(response.data.first_period, response.data.second_period, response.data.last_week)
          // FirstPeriod Variables
          let sumAccepted = 0
          let countAccepted = 0
          let sumAverageBuyback = 0.0
          let sumPaid = 0
          let countPaid = 0
          let sumReturn = 0
          let countReturn = 0
          let resultRevenuaLeadAverage = 0.0
          let firstSumApproved = 0
          let firstSumPaid = 0
          // SecondPeriod Variables
          let sumAcceptedSecond = 0
          let countAcceptedSecond = 0
          let sumAverageBuybackSecond = 0.0
          let sumPaidSecond = 0
          let countPaidSecond = 0
          let sumReturnSecond = 0
          let countReturnSecond = 0
          let resultRevenuaLeadAverageSecond = 0.0
          let sumApprovedSecond = 0
          // First Massiv
          let revenuaLead1 = []
          let revenuaLead2 = []
          let paid1 = []
          let paid2 = []
          map(firstPeriod, (d) => {
            if (d.approved && d.buyout) {
              paid1.push(parseFloat(((parseFloat(d.buyout) / parseFloat(d.approved)) * 100)))
            } else {
              paid1.push('')
            }
            // RevenuaLead
            let rateFirst = d.average_buyout_local / d.average_buyout_usd
            let percentPaid = Helper.percents(d.approved, d.buyout).replace('%', '').replace(',', '.')
            let revenuaLead = (d.average_buyout_usd * (parseFloat(percentPaid) / 100)).toFixed(2)
            revenuaLead1.push((parseFloat(revenuaLead) / parseFloat(rateFirst)).toFixed(2))
            // RevenuaLead
            if (d.approved > 0) {
              firstSumApproved += parseInt(d.approved)
              firstSumApproved = firstSumApproved++
              countAccepted++
              sumAccepted += parseInt(d.approved)
              sumAverageBuyback += parseFloat(d.average_buyout_usd) * parseInt(d.buyout)
            }
            if (d.buyout > 0) {
              firstSumPaid += parseInt(d.buyout)
              sumPaid += parseInt(d.buyout)
              countPaid++
            }
            if (d.return > 0) {
              sumReturn += parseInt(d.return)
              countReturn++
            }
            this.$nextTick(function () {
              let rezultDeviation = 0.0
              rezultDeviation = -(1 - revenuaLead / resultRevenuaLeadAverage) * 100
              this.rows_first.push({
                operator: {
                  value: d.operator_id ? `${Helper.getOperatorLogin(this.operators, d.operator_id)}` : '-',
                  percentBg: false,
                  popup: true
                },
                accepted: {
                  value: d.approved,
                  isCollspaned: true,
                  ocb: (value) => {
                    return Helper.getRawNumber(value)
                  }
                },
                averageBuyback: {
                  value: d.average_buyout_usd ? '$ ' + d.average_buyout_usd.toFixed(2) : '$ 0,00'
                    // bgg: Helper.renderSingleGist(100, Helper.averageBill(d.average_buyout, false, true))
                },
                paid: {
                  value: d.buyout,
                  bgg: Helper.renderGistPart(d.approved, d.buyout),
                  isCollspaned: true
                },
                paidPercents: {
                  value: d.approved && d.buyout ? Helper.percents(parseInt(d.approved), parseInt(d.buyout)) : '',
                  bgg: Helper.renderGistPart(d.approved, d.buyout, true),
                  webGraph: true,
                  webGraphSymbol: '%'
                },
                return: {
                  value: d.return,
                  bgg: Helper.renderGistPart(d.approved, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: d.approved && d.return ? Helper.percents(d.approved, d.return) : '0%',
                  bgg: Helper.renderGistPart(d.approved, d.return, true)
                },
                revenue_lead: {
                  value: revenuaLead > 0 ? '$ ' + revenuaLead : '$ 0,00'
                },
                deviation_mean: {
                  value: !isNaN(rezultDeviation) ? rezultDeviation.toFixed(2) + '%' : '0%',
                  plusBg: rezultDeviation >= 0
                }
              })
            })
          })
          let sumAverageBuybackRevenua = Helper.averageBillDayCount(sumAverageBuyback, sumPaid).replace('$', '').replace(',', '.')
          let paidPercentsRevenua = Helper.percents(sumAccepted, sumPaid).replace('%', '').replace(',', '.')
          resultRevenuaLeadAverage = (sumAverageBuybackRevenua * paidPercentsRevenua / 100).toFixed(2)
          this.firstFootColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            accepted: {
              value: `${sumAccepted}`
            },
            averageBuyback: {
              value: Helper.averageBillDayCount(sumAverageBuyback, sumPaid)
            },
            paid: {
              value: `${sumPaid}`
            },
            paidPercents: {
              value: Helper.percents(firstSumApproved, firstSumPaid)
            },
            return: {
              value: `${sumReturn}`
            },
            returnPercents: {
              value: Helper.percents(firstSumApproved, sumReturn)
            },
            revenue_lead: {
              value: `$ ${resultRevenuaLeadAverage}`
            }
          }
          // Second Massiv
          map(secondPeriod, (d) => {
            if (d.approved && d.buyout) {
              paid2.push(parseFloat(((parseFloat(d.buyout) / parseFloat(d.approved)) * 100)))
            } else {
              paid2.push('')
            }
            // RevenuaLead
            let rateSecond = d.average_buyout_local / d.average_buyout_usd
            let percentPaid = Helper.percents(d.approved, d.buyout).replace('%', '').replace(',', '.')
            let revenuaLead = (d.average_buyout_usd * (parseFloat(percentPaid) / 100)).toFixed(2)
            revenuaLead2.push((parseFloat(revenuaLead) / parseFloat(rateSecond)).toFixed(2))
            // RevenuaLead
            if (d.approved > 0) {
              countAcceptedSecond++
              sumAcceptedSecond += parseInt(d.approved)
              sumAverageBuybackSecond += parseFloat(d.average_buyout_usd) * parseInt(d.buyout)
            }
            if (d.approved > 0) {
              sumApprovedSecond += parseInt(d.approved)
              sumApprovedSecond = sumApprovedSecond++
            }
            if (d.buyout > 0) {
              sumPaidSecond += parseInt(d.buyout)
              countPaidSecond++
            }
            if (d.return > 0) {
              sumReturnSecond += parseInt(d.return)
              countReturnSecond++
            }
            this.$nextTick(function () {
              let rezultDeviationSecond = 0.0
              rezultDeviationSecond = -(1 - revenuaLead / resultRevenuaLeadAverage) * 100
              this.rows_second.push({
                operator: {
                  value: d.operator_id ? `${Helper.getOperatorLogin(this.operators, d.operator_id)}` : '-',
                  percentBg: false,
                  popup: true
                },
                accepted: {
                  value: d.approved,
                  ocb: (value) => {
                    return Helper.getRawNumber(value)
                  }
                },
                averageBuyback: {
                  value: d.average_buyout_usd ? '$ ' + d.average_buyout_usd.toFixed(2) : '$ 0,00'
                    // bgg: Helper.renderSingleGist(100, Helper.averageBill(d.average_buyout, false, true))
                },
                paid: {
                  value: d.buyout,
                  bgg: Helper.renderGistPart(d.approved, d.buyout),
                  isCollspaned: true
                },
                paidPercents: {
                  value: d.approved && d.buyout ? Helper.percents(parseInt(d.approved), parseInt(d.buyout)) : '',
                  bgg: Helper.renderGistPart(d.approved, d.buyout, true),
                  webGraph: true,
                  webGraphSymbol: '%'
                },
                return: {
                  value: d.return,
                  bgg: Helper.renderGistPart(d.approved, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: d.approved && d.return ? Helper.percents(d.approved, d.return) : '0%',
                  bgg: Helper.renderGistPart(d.approved, d.return, true)
                },
                revenue_lead: {
                  value: revenuaLead > 0 ? '$ ' + revenuaLead : '$ 0,00'
                },
                deviation_mean: {
                  value: !isNaN(rezultDeviationSecond) ? rezultDeviationSecond.toFixed(2) + '%' : '',
                  plusBg: rezultDeviationSecond >= 0
                }
              })
            })
          })
          let sumAverageBuybackRevenuaSecond = Helper.averageBillDayCount(sumAverageBuybackSecond, sumPaidSecond).replace('$', '').replace(',', '.')
          let paidPercentsRevenuaSecond = Helper.percents(sumAcceptedSecond, sumPaidSecond).replace('%', '').replace(',', '.')
          resultRevenuaLeadAverageSecond = (sumAverageBuybackRevenuaSecond * paidPercentsRevenuaSecond / 100).toFixed(2)
          this.secondFootColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            accepted: {
              value: `${sumAcceptedSecond}`
            },
            averageBuyback: {
              value: Helper.averageBillDayCount(sumAverageBuybackSecond, sumPaidSecond)
            },
            paid: {
              value: `${sumPaidSecond}`
            },
            paidPercents: {
              value: Helper.percents(sumApprovedSecond, sumPaidSecond)
            },
            return: {
              value: `${sumReturnSecond}`
            },
            returnPercents: {
              value: Helper.percents(sumApprovedSecond, sumReturnSecond)
            },
            revenue_lead: {
              value: `$ ${resultRevenuaLeadAverageSecond}`
            }
          }
          // Defference Massiv
          for (let i = 0; i < revenuaLead1.length; i++) {
            let paidValue = 0
            if ((paid2[i] && paid1[i])) {
              paidValue = (paid2[i] - paid1[i])
            } else if (!paid2[i] && paid1[i]) {
              paidValue = paid1[i]
            } else {
              paidValue = paid2[i]
            }
            this.rows_difference.push({
              revenue_lead: {
                value: !isNaN((revenuaLead2[i] - revenuaLead1[i]).toFixed(2)) ? '$ ' + (revenuaLead2[i] - revenuaLead1[i]).toFixed(2) : '$ 0,00'
              },
              paid: {
                value: paidValue ? paidValue.toFixed(1) + '%' : paidValue,
                minusBg: paidValue <= 0
              }
            })
          }
          // LstPeriod Massiv
          map(lastPeriod, (d) => {
            this.rows_last.push({
              operator: {
                value: d.operator_id ? `${Helper.getOperatorLogin(this.operators, d.operator_id)}` : '-',
                popup: true
              },
              processed: {
                value: d.total,
                bg: true,
                ocb: (value) => {
                  return Helper.getRawNumber(value)
                }
              }
            })
          })
        })
      }
    }
  }
</script>

<style>
    .operatorsAnalysis thead th:nth-child(3) {
        min-width: 115px;
    }

    .operatorsAnalysis tr {
        height: 46px;
    }

    .operatorsAnalysis .container__table {
        display: flex;
        overflow-x: scroll;
    }

    .operatorsAnalysis filters__atalytics {
        margin-bottom: 20px;
        width: 100%;
    }

    .operatorsAnalysis .filters__atalytics--content {
        background-color: #fff;
        padding: 10px;
        display: flex;
    }

    .first-period {
        margin-right: 10px;
    }

    .table_difference {
        margin-left: 10px;
        margin-right: 10px;
    }

    .operatorsAnalysis filters__atalytics {
        margin-bottom: 20px;
        width: 100%;
    }

    .operatorsAnalysis .filters__atalytics--content {
        background-color: #fff;
        padding: 10px;
        display: flex;
    }

    .percent-label {
        margin-bottom: 0px;
    }

    #percent {
        padding: 3px 10px;
        color: #35495e;
        font-size: 14px;
        margin-right: 10px;
    }

    .operatorsAnalysis .percentBg {
        background-color: rgb(250, 187, 125);
    }
    .operatorsAnalysis tbody td {
        white-space: nowrap;
    }

</style>



// WEBPACK FOOTER //
// OperatorsAnalysis.vue?75f95449